import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { DocumentLinkCreated } from '../../documentLink/DocumentLinkCreated'

@InputType()
export class CreateLogisticDocumentLinkArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string
}

export interface ICreateLogisticDocumentLink extends IAction<DocumentLinkCreated, CreateLogisticDocumentLinkArgs> {}
